import { ErrorHandler, Injector, NgZone } from '@angular/core';
import { DeviceDetectorService } from 'ngx-device-detector';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { NiUiLog } from './ni-ui-log';
import { ApiConfiguration } from '../../api/api-configuration';

export class NiErrorHandler implements ErrorHandler {
  constructor(private injector: Injector) {}

  handleError(error: any): void {
    console.error(error);

    const rtId = Math.random().toString(36).substring(7).toLocaleUpperCase();
    const message = error.message ? error.message : error.toString();

    if (error instanceof HttpErrorResponse) {
      this.handleResponse(error);
    } else if (
      error.rejection &&
      error.rejection instanceof HttpErrorResponse
    ) {
      this.handleResponse(error.rejection);
    } else {
      this.sendError(message, rtId, error.stack);
    }
  }

  sendError(message: string, rtId: string, stack = '') {
    const deviceService = this.injector.get(DeviceDetectorService);
    const deviceInfo = deviceService.getDeviceInfo();
    const httpClient = this.injector.get(HttpClient);
    const apiConf = this.injector.get(ApiConfiguration);
    const logDTO: NiUiLog = {
      level: 5,
      message: message.substr(0, Math.min(message.length, 1000)),
      stackTrace: stack.substr(0, Math.min(stack.length, 4000)),
      browser: deviceInfo.browser,
      browserVersion: deviceInfo.browser_version,
      os: deviceInfo.os,
      osVersion: deviceInfo.os_version,
      device: deviceInfo.device,
    };

    const headers = new HttpHeaders({ 'X-RequestTrackingId': rtId, 'no-spinner': 'true' });

    httpClient
      .post<any>(`${apiConf.rootUrl}/api/logs`, logDTO, { headers: headers })
      .subscribe((r) => {
        console.log('Error logged to server');
        if (!this.skipErrorPage(message)) {
          this.gotErrorPage(rtId);
        }
      });
  }

  private handleResponse(response: HttpErrorResponse) {
    //TODO handle global server error
  }

  private gotErrorPage(rtId: string) {
    this.injector.get(NgZone).run(() => {
      location.href = `/en-us/search/error.html`;
    });
  }

  skipErrorPage(message: string) {
    return (
      message.indexOf('ExpressionChangedAfterItHasBeenCheckedError') >= 0 ||
      message.indexOf('satellite') >= 0
    );
  }
}
